export enum FormFieldKeySpecialTypeEnum {
    FirstName = 1,
    Age = 2,
    DateOfBirth = 3,
    CompetitionLicenseNumber = 4,
    MediaLicenseNumber = 5,
    OfficialLicenseNumber = 6,
    Address = 7,
    Nationality = 8,
    County = 9,
    PostalCode = 10,
    RacingClubId = 11,
    RacingClubName = 12,
    LastName = 13,
    GenderId = 14,
    GenderName = 15,
    Email = 16,
    IsFirstTimeLicense = 17,
    IsGardaVettingValid = 18,
    GardaVettingExpiryDate = 19,
    HasInternationalLicense = 20,
    HasIrds = 21,
    CreditPoints = 22,
    LatestLicenseYear = 23,
    Country = 24
}